import { Component, Vue } from 'vue-facing-decorator';
import { MatchMediaEvent, MediaThreshold } from "webshop-modules";

@Component({
    name: "BreakpointHandler",
})
export class BreakpointHandler extends Vue {
    protected gadgetBreakpoint: MediaQueryList = window.matchMedia(MediaThreshold.GADGET);
    protected mobileBreakpoint: MediaQueryList = window.matchMedia(MediaThreshold.MOBILE);
    protected tabletBreakpoint: MediaQueryList = window.matchMedia(MediaThreshold.TABLET);
    protected desktopBreakpoint: MediaQueryList = window.matchMedia(MediaThreshold.DESKTOP);

    public isMobile = false;
    public isGadget = false;

    protected handleBreakpointChange(event?: MediaQueryListEvent): void {
        this.isMobile = this.mobileBreakpoint.matches;
        this.isGadget = this.gadgetBreakpoint.matches;
    }

    protected handleBreakpointInitialization(): void {
        this.handleBreakpointChange();
    }

    protected handleGadgetChange(event: MediaQueryListEvent): void {
        this.handleBreakpointChange(event);
    }

    protected handleMobileChange(event: MediaQueryListEvent): void {
        this.handleBreakpointChange(event);
    }

    protected handleTabletChange(event: MediaQueryListEvent): void {
        this.handleBreakpointChange(event);
    }

    protected handleDesktopChange(event: MediaQueryListEvent): void {
        this.handleBreakpointChange(event);
    }

    protected mounted(): void {
        this.handleBreakpointInitialization();

        try {
            this.gadgetBreakpoint.addEventListener(MatchMediaEvent.CHANGE, this.handleGadgetChange);
            this.desktopBreakpoint.addEventListener(MatchMediaEvent.CHANGE, this.handleDesktopChange);
            this.tabletBreakpoint.addEventListener(MatchMediaEvent.CHANGE, this.handleTabletChange);
            this.mobileBreakpoint.addEventListener(MatchMediaEvent.CHANGE, this.handleMobileChange);
        } catch (e) {
            this.gadgetBreakpoint.addListener(this.handleGadgetChange);
            this.desktopBreakpoint.addListener(this.handleDesktopChange);
            this.tabletBreakpoint.addListener(this.handleTabletChange);
            this.mobileBreakpoint.addListener(this.handleMobileChange);
        }
    }

    protected destroyed(): void {
        try {
            this.gadgetBreakpoint.removeEventListener(MatchMediaEvent.CHANGE, this.handleGadgetChange);
            this.desktopBreakpoint.removeEventListener(MatchMediaEvent.CHANGE, this.handleDesktopChange);
            this.tabletBreakpoint.removeEventListener(MatchMediaEvent.CHANGE, this.handleTabletChange);
            this.mobileBreakpoint.removeEventListener(MatchMediaEvent.CHANGE, this.handleMobileChange);
        } catch (e) {
            this.gadgetBreakpoint.removeListener(this.handleGadgetChange);
            this.desktopBreakpoint.removeListener(this.handleDesktopChange);
            this.tabletBreakpoint.removeListener(this.handleTabletChange);
            this.mobileBreakpoint.removeListener(this.handleMobileChange);
        }
    }
}
